// @ts-nocheck
import React from 'react';
import { LocalizationEntity } from '../../shared/models/localization';
import LocalizationHelper from '../../helpers/TranslationHelper';

const KanbanButton: React.FC<{
  list?: boolean;
  showButtonText?: boolean;
  buttonText?: string;
  showButtonIcon?: boolean;
  buttonIcon?: string;
  customButtonClass?: string;
  localization?: LocalizationEntity[];
  onClick?: () => void;
}> = ({
  list,
  showButtonText = true,
  buttonText,
  showButtonIcon = true,
  buttonIcon,
  customButtonClass,
  localization,
  onClick,
}) => {
  const hintText = list
    ? LocalizationHelper.getLocaleEntityValue(
        localization,
        'ZSite.Frontend.Kanban.Hint.AddCardButton',
        'Add another list'
      )
    : LocalizationHelper.getLocaleEntityValue(
        localization,
        'ZSite.Frontend.Kanban.Hint.AddCardButton',
        'Add another card'
      );

  if (!buttonText) {
    buttonText = list ? 'Add another list' : 'Add another card';
  }
  if (!customButtonClass) {
    customButtonClass = list ? 'add-list-button' : 'add-card-button';
  }

  const buttonClasses = `kanban-column__button ${customButtonClass}`;

  return (
    <div title={hintText} className={buttonClasses} onClick={onClick}>
      {showButtonIcon && <i className={buttonIcon ?? 'fa fa-plus'} />}
      {showButtonText && <strong>{buttonText}</strong>}
    </div>
  );
};

export default KanbanButton;
